import { Box, Theme } from "@outschool/backpack";
import React, { useEffect, useRef } from "react";

import { ConciergeRequestCompleteButtons } from "./ActionButtons";
import { useChatContext } from "./chatProvider";
import { LoadingMessage } from "./components/LoadingMessage";
import { ConciergeChatMessage } from "./conciergeChat/ConciergeChatMessage";
import { ConciergeInput } from "./conciergeChat/ConciergeInput";
import { MESSAGE_ID } from "./consts";

export const ChatWindow = () => {
  const { currentMessageId, conversation } = useChatContext();
  const bottomRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (bottomRef?.current) {
      // Scroll to div at bottom of screen when new messages arrive
      // Use timeout so that scroll always occurs after render
      let timer = setTimeout(function () {
        bottomRef.current?.scrollIntoView({ behavior: "smooth", block: "end" });
      }, 100);

      return () => {
        clearTimeout(timer);
      };
    } else {
      return;
    }
  }, [currentMessageId, conversation]);

  return (
    <Box
      flex
      sx={(theme: Theme) => ({
        padding: theme.spacing(16),
        width: "100%",
        overflowY: "auto",

        [theme.breakpoints.down("md")]: {
          height: "92.5dvh"
        },
        [theme.breakpoints.up("md")]: {
          maxHeight: "50dvh",
          height: "50dvh"
        }
      })}
    >
      <Box
        flex
        sx={{
          flexDirection: "column",
          gap: "1rem",
          marginTop: "auto",
          width: "100%"
        }}
      >
        {/*render conversations */}
        {conversation?.map((message, index) => (
          <React.Fragment key={index}>{message.render()}</React.Fragment>
        ))}

        {currentMessageId === MESSAGE_ID.CONCIERGE_REQUEST && (
          <>
            <ConciergeChatMessage />
            <ConciergeInput />
          </>
        )}
        {currentMessageId === MESSAGE_ID.CONCIERGE_REQUEST_RECEIVED && (
          <>
            <ConciergeRequestCompleteButtons />
          </>
        )}

        {currentMessageId === MESSAGE_ID.LOADING && <LoadingMessage />}

        <div ref={bottomRef} />
      </Box>
    </Box>
  );
};
